module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/031-64863ec349e48ce687fb36e51f6d178b.jpg";